(() => {
    class ImageResourceService {
        constructor(DashboardConfig) {
         this.dashboardConfig = DashboardConfig;
        }

        getUrlScheme() {
            return location.protocol
        }
        resolveImageUrl(url) {
            if (!url) {
                return url;
            }

            const sanitizedUrl = /^http(s?)\:\/\//.test(url) ?
                url : `${this.getUrlScheme()}//` + url.replace(/^[\:\/]*/, "")


            return this.dashboardConfig.ImageResizeServiceUrl
                ? `${ this.dashboardConfig.ImageResizeServiceUrl }?url=${ encodeURIComponent(sanitizedUrl) }`
                : sanitizedUrl
        }
        getUrlForResource(resourceId) {
            const resourceUrl = `${this.dashboardConfig.APIServer}/api/resource/?id=${ resourceId }`
            return this.resolveImageUrl(resourceUrl);
        }
    }

    angular.module("dashboard")
        .service("ImageResourceService", ["DashboardConfig", ImageResourceService ])
})();
